import {
  EnhancedInterestResponse,
  IInterestResponse,
} from '@pages/Root/services/api/interest/interest-model-definitions.ts';
import {
  API_URL,
  DEFAULT_ASPECT,
  DEFAULT_CKEY, getInitializedMomentFetcher,
} from '@moment/net/fetch-contstants.ts';
import { resolvedLanguage } from '@/i18n.ts';

export const INTEREST_QUERY_KEY = 'interests'

export const fetchInterests = (params?: { lang?: string }) => async () => {
  try {
    const language = params?.lang || resolvedLanguage('en');
    const momentFetcher = await getInitializedMomentFetcher()
    const url = `${API_URL}/wp/v1/interests?ckey=${DEFAULT_CKEY}&mp_lang=${language}&previewAspect=${DEFAULT_ASPECT}`;
    const response = await momentFetcher.fetch(url);
    const rawInterest: IInterestResponse = await response.json();
    return new EnhancedInterestResponse(rawInterest);
  } catch (e: any) {
    console.warn(e);
    return null;
  }
};
